import React from "react";
import PropTypes, { object } from "prop-types";
import { Box, Flex } from "@chakra-ui/react";
import { defaultTemplates } from "./defaultTemplates.json";
import TemplateItem from "./TemplateItem";

const TemplateList = ({
  templates,
  onClickUseTemplateHandler,
  onClickPreviewHandler,
}) => {
  const blankTemplateProperties = {
    imageUrl: "https://i.ibb.co/vVY4c7r/blank-template.png",
    id: "blank_template",
    description: "Build your form from scratch.",
    title: "Blank template",
  };
  const blankTemplate = () => {
    return (
      <TemplateItem
        key={blankTemplateProperties.id}
        properties={blankTemplateProperties}
        useTemplateHandler={onClickUseTemplateHandler}
        previewHandler={onClickPreviewHandler}
      />
    );
  };
  const renderDefaultTemplates = () => {
    let filterTemplates = null;
    if (templates.length) {
      filterTemplates = defaultTemplates.filter((defaultTemplate) => {
        return Boolean(
          !templates.filter(
            (customTemplate) => customTemplate.id == defaultTemplate.id
          ).length
        );
      });
    } else {
      filterTemplates = defaultTemplates;
    }
    const mapTemplates = filterTemplates.map((item, index) => {
      return (
        <TemplateItem
          key={item.id}
          properties={item}
          useTemplateHandler={onClickUseTemplateHandler}
          previewHandler={onClickPreviewHandler}
        />
      );
    });
    return mapTemplates;
  };
  const renderTemplateItems = () => {
    if (templates.length) {
      const mapTemplates = templates.map((item, index) => {
        return (
          <TemplateItem
            key={item.id}
            properties={item}
            useTemplateHandler={onClickUseTemplateHandler}
            previewHandler={onClickPreviewHandler}
          />
        );
      });
      mapTemplates.push(blankTemplate());
      return [...renderDefaultTemplates(), ...mapTemplates];
    }
    return [...renderDefaultTemplates(), blankTemplate()];
  };
  return (
    <Box mt="5">
      <Flex wrap="wrap" justify="flex-start" flexWrap="wrap">
        {renderTemplateItems()}
      </Flex>
    </Box>
  );
};
TemplateList.propTypes = {
  templates: PropTypes.arrayOf(object).isRequired,
  onClickUseTemplateHandler: PropTypes.func.isRequired,
  onClickPreviewHandler: PropTypes.func.isRequired,
};

export default TemplateList;
